import {
  DensityUom,
  DimsUom,
  HandlingUnit,
  HazmatData,
  IShipmentLineItem,
  SourceSystem,
  TemperatureSettings,
  VolumeUom,
  WeightUom,
} from '@rygen/rygen-ui/model';
import { ICostAllocationShipmentLineItem } from '@rygen/rygen-ui/model/costAllocation';
import { ShipmentOrderReference } from '@rygen/rygen-ui/model/shipmentFinancials';

import { BillingShipmentReferenceNumber } from './BillingShipmentReferenceNumber';

// prettier-ignore
export class BillingShipmentLineItem implements IShipmentLineItem, ICostAllocationShipmentLineItem {
  id?: number;
  shipmentId?: number;
  sourceSystemId?: string;
  sourceSystem?: SourceSystem;
  description?: string;
  handlingUnit?: HandlingUnit;
  packagingQty?: number;
  packagingUnit?: HandlingUnit;
  plannedFreightClass?: string;
  plannedWeight?: number;
  plannedQuantity?: number;
  billedFreightClass?: string;
  billedWeight?: number;
  billedQuantity?: number;
  weightUom?: WeightUom;
  linear?: number;
  linearUom?: DimsUom;
  volume?: number;
  volumeUom?: VolumeUom;
  lengthDim?: number;
  widthDim?: number;
  heightDim?: number;
  dimensionalUom?: DimsUom;
  density?: number;
  densityUom?: DensityUom;
  nmfcNumber?: string;
  stackable = false;
  hazmatData: HazmatData = new HazmatData();
  temperatureSettings: TemperatureSettings = new TemperatureSettings();
  specialInstructions?: string;
  order?: ShipmentOrderReference;
  referenceNumbers: BillingShipmentReferenceNumber[] = [];

  constructor(opts?: Partial<BillingShipmentLineItem>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.sourceSystemId != null) {
      this.sourceSystemId = opts.sourceSystemId;
    }
    if (opts?.sourceSystem != null) {
      if (typeof opts?.sourceSystem === 'string') {
        this.sourceSystem = SourceSystem[opts.sourceSystem];
      } else {
        this.sourceSystem = opts.sourceSystem;
      }
    }
    if (opts?.shipmentId != null) {
      this.shipmentId = opts.shipmentId;
    }
    if (opts?.plannedQuantity != null) {
      this.plannedQuantity = opts.plannedQuantity;
    }
    if (opts?.billedQuantity != null) {
      this.billedQuantity = opts.billedQuantity;
    }
    if (opts?.description != null) {
      this.description = opts.description;
    }
    if (opts?.handlingUnit != null) {
      this.handlingUnit = new HandlingUnit(opts.handlingUnit);
    }
    if (opts?.packagingQty != null) {
      this.packagingQty = opts.packagingQty;
    }
    if (opts?.packagingUnit != null) {
      this.packagingUnit = new HandlingUnit(opts.packagingUnit);
    }
    if (opts?.plannedFreightClass != null) {
      this.plannedFreightClass = opts.plannedFreightClass;
    }
    if (opts?.plannedWeight != null) {
      this.plannedWeight = opts.plannedWeight;
    }
    if (opts?.billedFreightClass != null) {
      this.billedFreightClass = opts.billedFreightClass;
    }
    if (opts?.billedWeight != null) {
      this.billedWeight = opts.billedWeight;
    }
    if (opts?.weightUom != null) {
      this.weightUom = opts.weightUom;
    }
    if (opts?.linear != null) {
      this.linear = opts.linear;
    }
    if (opts?.linearUom != null) {
      this.linearUom = opts.linearUom;
    }
    if (opts?.volume != null) {
      this.volume = opts.volume;
    }
    if (opts?.volumeUom != null) {
      this.volumeUom = opts.volumeUom;
    }
    if (opts?.lengthDim != null) {
      this.lengthDim = opts.lengthDim;
    }
    if (opts?.widthDim != null) {
      this.widthDim = opts.widthDim;
    }
    if (opts?.heightDim != null) {
      this.heightDim = opts.heightDim;
    }
    if (opts?.dimensionalUom != null) {
      this.dimensionalUom = opts.dimensionalUom;
    }
    if (opts?.density != null) {
      this.density = opts.density;
    }
    if (opts?.densityUom != null) {
      this.densityUom = opts.densityUom;
    }
    if (opts?.nmfcNumber != null) {
      this.nmfcNumber = opts.nmfcNumber;
    }
    if (opts?.stackable != null) {
      this.stackable = opts.stackable;
    }
    if (opts?.hazmatData != null) {
      this.hazmatData = new HazmatData(opts.hazmatData);
    }
    if (opts?.temperatureSettings != null) {
      this.temperatureSettings = new TemperatureSettings(
        opts.temperatureSettings,
      );
    }
    if (opts?.specialInstructions != null) {
      this.specialInstructions = opts.specialInstructions;
    }
    if (opts?.order != null) {
      this.order = new ShipmentOrderReference(opts.order);
    }
    if (opts?.referenceNumbers != null) {
      this.referenceNumbers = opts.referenceNumbers.map(
        (val) => new BillingShipmentReferenceNumber(val),
      );
    }
  }

  get weight(): number | undefined {
    return this.billedWeight ?? this.plannedWeight;
  }

  get quantity(): number | undefined {
    return this.billedQuantity ?? this.plannedQuantity;
  }
}
